export const formatMaxCount: (cur: number, max: number) => string = (c, m) => {
  const maxString = m > 0 ? `/${m}` : "";
  return `${c}${maxString}`;
};
